import { render, staticRenderFns } from "./DisableSchoolDialog.vue?vue&type=template&id=1fea8f86&scoped=true&"
import script from "./DisableSchoolDialog.vue?vue&type=script&lang=js&"
export * from "./DisableSchoolDialog.vue?vue&type=script&lang=js&"
import style0 from "./DisableSchoolDialog.vue?vue&type=style&index=0&id=1fea8f86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fea8f86",
  null
  
)

export default component.exports